(function ($) {
   "use strict";

   class Localisation {
      constructor() {
         this.galleries = [];
         this.init();
      }

      init() {
         this.initGalleries();
         this.bindEvents();
      }

      bindEvents() {
         let resizeTimer;
         $(window).on("resize", () => {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(() => {
               this.handleResize();
            }, 250);
         });
      }

      initGalleries() {
         const windowWidth = $(window).width();
         $(".c-localisation__gallery").each((index, element) => {
            const $gallery = $(element);
            if ($gallery.closest(".c-panel").length === 0) {
               this.galleries.push($gallery);

               if (windowWidth < 768) {
                  this.initSlider($gallery);
               }
            } else {
            }
         });
      }

      initSlider($gallery) {
         if ($gallery.length && !$gallery.hasClass("slick-initialized")) {
            try {
               $gallery.slick({
                  dots: true,
                  infinite: false,
                  slidesToShow: 1,
                  slidesToScroll: 1,
                  arrows: false,
                  draggable: true,
                  adaptiveHeight: true,
                  swipe: true,
                  touchMove: true,
                  touchThreshold: 5,
               });

               $gallery.on("click", ".slick-dots button", function (e) {
                  e.preventDefault();
               });
            } catch (error) {
               console.error("Localisation: Error initializing slick:", error);
            }
         } else {
         }
      }

      destroySlider($gallery) {
         if ($gallery.hasClass("slick-initialized")) {
            $gallery.slick("unslick");
         }
      }

      handleResize() {
         const windowWidth = $(window).width();

         this.galleries.forEach(($gallery) => {
            if (windowWidth < 768 && !$gallery.hasClass("slick-initialized")) {
               this.initSlider($gallery);
            } else if (
               windowWidth >= 768 &&
               $gallery.hasClass("slick-initialized")
            ) {
               this.destroySlider($gallery);
            }
         });
      }
   }

   $(document).ready(() => {
      new Localisation();
   });

   window.Localisation = Localisation;
})(jQuery);
